import { FC, useEffect } from "react";

import useAuthData from "@modules/auth/hooks/useAuthData";
import { pushPurchase } from "@modules/gtm";

import type { TPaymentStatus } from "../../types";

type TPurchaseDataLayerEventProps = {
  paymentStatus: TPaymentStatus;
};

const PurchaseDataLayerEvent: FC<TPurchaseDataLayerEventProps> = ({ paymentStatus }) => {
  const [authData] = useAuthData();

  useEffect(() => {
    pushPurchase(paymentStatus, { email: authData?.email, phone: authData?.phone });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default PurchaseDataLayerEvent;

